<div class="logo-container" aria-label="Zenity Logo">
  <img src="assets/images/logo/zenity-logo.svg" alt="Zenity icon" />
  <div class="large-logo-mask">
    <img class="large-logo" src="assets/images/logo/zenity-text.svg" alt="Zenity text logo" />
  </div>

  <button
    class="menu-control-button-aligned"
    [tabindex]="menuExpanded ? 0 : -1"
    (click)="toggleMenuExtension()"
    aria-label="Toggle menu extension"
    matTooltip="{{ menuExtended ? 'Collapse' : 'Expand' }}"
    matTooltipPosition="right"
    [matTooltipShowDelay]="1500"
  >
    <lucide-icon
      [name]="menuExtended ? 'arrow-left-to-line' : 'arrow-right-to-line'"
      [size]="18"
      [strokeWidth]="1.5"
    ></lucide-icon>
  </button>
</div>

<div class="menu-content">
  <nav #menuitems role="menubar" class="menu-items" aria-label="Main navigation menu">
    <div
      #selectedindicator
      class="selected-indicator"
      [ngStyle]="{
        '--selected-index-top.px': selectedIndexTop,
        '--selected-index-height.px': selectedIndexHeight,
        opacity: selectedIndexOpacity,
      }"
    ></div>

    @for (appPage of appPages(); track appPage?.displayName; let i = $index) {
      <app-nav-menu-item
        [appPage]="appPage"
        [menuExpanded]="menuExpanded"
        [index]="i"
        (expansionToggle)="onExpansionToggle($event)"
      ></app-nav-menu-item>
    }
  </nav>

  <div class="spacer"></div>

  <nav class="menu-bottom" role="menubar" aria-label="Support links">
    @for (supportSectionRefPage of supportSectionRefPages(); track supportSectionRefPage?.displayName; let i = $index) {
      <app-nav-menu-item [appPage]="supportSectionRefPage" [menuExpanded]="menuExpanded"></app-nav-menu-item>
    }
  </nav>
</div>
